import {GROUPES} from 'redux/actionTypes';

const defaultEstimate = {
	width: false,
	height: false,
	colors: []
};

const initialState = {
	group: false,
	groupes: [],
	estimate: {
		...defaultEstimate
	},
	fetchingEstimate: false,
	loadedEstimate: false,
	moveGroup: false,
	fetching: false
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GROUPES.RESET_ESTIMATE: {
			return {
				...state,
				estimate: {
					...defaultEstimate
				},
				fetchingEstimate: false,
				loadedEstimate: false,
			};
		}
		case GROUPES.LOADING: {
			let {fetching} = action.payload;

			return {
				...state,
				fetching
			};
		}
		case GROUPES.LOADING_ESTIMATE: {
			let {fetching} = action.payload;

			return {
				...state,
				fetchingEstimate: fetching
			};
		}
		case GROUPES.SET_ESTIMATE: {
			let {estimate} = action.payload;
			return {
				...state,
				estimate,
				loadedEstimate: true,
				fetchingEstimate: false
			};
		}
		case GROUPES.ACTIVE_MOVE: {
			let {group} = action.payload;
			let nextState = {
				moveGroup: group
			}
			return {
				...state,
				...nextState
			};
		}
		case GROUPES.SET_CURRENT: {
			let {group} = action.payload;
			return {
				...state,
				group
			};
		}
		case GROUPES.SET_GROUPES: {
			let {groupes} = action.payload;
			let defaultGroup = false;
			if (groupes && typeof groupes.map === 'function') {
				groupes.map((groupData) => {
					if (groupData.default) {
						defaultGroup = groupData.group;
					}
					return false;
				});
			}

			let newState = {
				...state,
				groupes
			};
			newState.group = defaultGroup;
			return newState;
		}
		default:
			return state;
	}
};

export default reducer;
